module.exports = __webpack_public_path__ + "img/sfdw_cn_hover.1ad67f61.png";